import { ActionButton } from "./ActionButton";

interface Props {
  onDismiss: Function;
  onSubmit: Function;
  header: string;
  children: JSX.Element;
}

export function RequestActionModal(props: Props) {
  return (
    <div
      className="tw-fixed tw-inset-0 tw-z-max tw-h-screen tw-w-screen tw-bg-zinc-800 tw-bg-opacity-50"
      onClick={(e) => {
        if (e.target == e.currentTarget) {
          props.onDismiss(false);
        }
      }}
      data-testid="request-action-modal"
    >
      <div className="tw-fixed tw-left-1/3 tw-mx-auto tw-my-[200px] tw-w-1/3 tw-rounded-lg tw-bg-blue-light-1 tw-bg-opacity-100 tw-shadow-2xl 1040:tw-left-[16.66666666%] 1040:tw-w-2/3">
        <div
          className="tw-absolute tw-right-0 tw-top-[5px] tw-cursor-pointer tw-p-[13px] tw-text-custom-blue"
          onClick={() => props.onDismiss(false)}
        >
          <i className="fa fa-xmark"></i>
        </div>
        <div className="tw-border-0 tw-border-b-2 tw-border-solid tw-border-custom-blue tw-p-[18px] tw-text-center tw-font-bold tw-text-custom-blue">
          {props.header}
        </div>

        <div className="tw-p-[18px] tw-text-custom-blue">{props.children}</div>

        <div className="tw-flex tw-justify-center tw-p-[18px]">
          <div className="tw-w-fit">
            <ActionButton
              text="Request Update"
              action={props.onSubmit}
              afterAction={() => setTimeout(() => props.onDismiss(false), 1000)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
